<section class="modal-content">
  <h2 class="modal-header">Modificar línea</h2>
  <h4 class="w-100 current-line-section">
    Linea: ${{ data.requestedLine | number }}
  </h4>
  <div>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Nueva línea</mat-label>
      <input
        [formControl]="requestedLine"
        mask="separator"
        thousandSeparator="."
        matInput
      />
      <mat-hint
        class="error-msg"
        *ngIf="requestedLine.touched && requestedLine.invalid"
      >
        <div
          class="text-error"
          *ngIf="requestedLine.errors && requestedLine.errors['required']"
        >
          Este campo es requerido
        </div>
        <div
          class="text-error"
          *ngIf="requestedLine.errors && requestedLine.errors['min']"
        >
          El monto no es valido
        </div>
      </mat-hint>
    </mat-form-field>
  </div>
  <div class="modal-footer">
    <button
      [disabled]="!requestedLine.valid"
      (click)="sendMinuteLineUpdate()"
      mat-raised-button
      color="primary"
    >
      Actualizar
    </button>
  </div>
</section>
